import { http } from '../../config/axios'

const findVoucher = (params: any): Promise<any> => {
  const { first, rows, page, idCampanha, sortField, sortOrder } = params ?? {};
  const pathParams = [first, rows, page, sortField, sortOrder]
    .map((v) => encodeURIComponent(v))
    .join('/');
  const queryParams: any = {};
  if (idCampanha) {
    queryParams.idCampanha = idCampanha;
  }
  return http
    .get('api/voucher/find/' + pathParams, { params: queryParams })
    .then((res) => res.data as any)
    .catch((error) => {
      console.error('Erro findVoucher', error)
      throw Error(error.response.data)
    })
}

export default findVoucher;
